import styled from 'styled-components';

export const Container = styled.section<{ disabledMaxWidth?: boolean }>`
  max-width: ${({ disabledMaxWidth }) =>
    disabledMaxWidth ? 'auto' : '1440px'};
  padding: 0;
  margin-inline: auto;
  position: relative;

  @media ${({ theme }) => theme.device.desktopL} {
    max-width: ${({ disabledMaxWidth }) =>
      disabledMaxWidth ? 'auto' : '2560px'};
  }
  /* Stops the app from scrolling behind the opened menu in mobile */
  &.fixed-height {
    max-height: var(--app-height);
    overflow: hidden;
  }
  &.zIndex {
    z-index: 1;
  }
`;

export default Container;
